import {IFiltersData} from "~/cabinet/vue/interface/filter/Interfaces";
import Dictionary from "~/ts/library/Dictionary";
import {IForm} from "~/cabinet/vue/interface/form/elements/Interfaces";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";
import Random from "~/ts/library/Random";

export interface WidgetInterface {
    id: string;
    descr: string;
    typeId: string;
    weight: number[];
    isNew: boolean;
    isConversionUsed: boolean;
    isMaskCounters: boolean;
}

export interface WidgetDataItemInterface {
    uniqueKey: string;
    descr: string[];
    color?: string;
    value: number;
    formattedValue: string;
    conversionValue?: number;
    groupByValueList: string[];
    groupByColumnValues: Dictionary<string | null>
}

export interface WidgetDataResultInterface {
    dataSource: {
        id: string;
        descr: string;
        isAvg: boolean;
        dimension: string;
        isSecondsDimension: boolean;
        groupByIdList: string[];
        groupByDictionary: Dictionary<GroupByInterface>;
        index: number;
        hasDetailDisplay: boolean;
    };
    error?: string;
    previousPeriodValue?: number;
    isShowHourNotSupportedWarning?: boolean,
    moreIsBetter: boolean;
    valuesByGroupById: Dictionary<(string | null)[]>;
    totalValue: number;
    totalFormattedValue: string;
    firstLevelGroupValueSum: Dictionary<number>;
    firstLevelGroupFormattedValueSum: Dictionary<string>;
    itemsByDate: {
        dateHumanDescr: string,
        items: WidgetDataItemInterface[];
    }[];
    totalItems?: WidgetDataItemInterface[];
    withConversion: boolean;
}

export type WidgetDataInterface = {
    result: WidgetDataResultInterface[];
    stacked: boolean;
    dashboard: {
        id: string;
        typeId: string;
    };
    widget: {
        id: string,
        typeId: string,
        isMaskCounters: boolean
    };
    dateRange: string[];
    isLibrary: boolean;
    dashboardGroupBy?: {
        id: string,
        value: string
    }
}

export interface DashboardExposeInterface {
    editWidget: (id?: string, typeId?: string, libraryWidgetId?: string, copyWidgetId?: string) => void
}

export interface DataSourceConfigInterface {
    id: string;
    descr: string;
    dataSourceId: string;
    dateTimeVariantId: string;
    analyticFunction: string;
    analyticFunctionForm: Dictionary<any>;
    groupByList: string[];
    groupLimit: number;
    segmentationFilters: any;
}

export function getNewDataSourceConfig(): DataSourceConfigInterface {
    //let dataSource = editWidgetDialog.value.response.dataSources[0];
    return {
        id: Random.uid(32),
        dataSourceId: null,//dataSource.id,
        groupByList: [],
        segmentationFilters: {},
        dateTimeVariantId: null,
        analyticFunction: null,//dataSource.analyticFunctions[0].id,
        analyticFunctionForm: null,
        descr: null,
        groupLimit: 10
    };
}


export interface DataSourceInterface {
    id: string;
    descr: string[];
    segmentationFilters?: IFiltersData | false;
    dashboardTypeId: string;
    groupByList: GroupByInterface[],
    analyticFunctions: {
        id: string;
        descr: string;
        additionalConfigForm?: IForm;
        isConversionAvailable: boolean;
    }[];
    dateTimeFields: {
        id: string;
        descr: string;
    }[];
}


export interface DashboardResponseInterface {
    widgets: WidgetInterface[];
    dividersByColumnCount: {
        columnCount: number;
        dividers: number[];
    }[];
    maxColumns: number;
    minColumnWidth: number;
    groupByValues: DashboardGroupByValueInterface[];
}

export interface DashboardGroupByValueInterface {
    value: string | number;
    descr: string;
}

export interface WidgetTypeInterface {
    id: string;
    descr: string;
    icon: string;
    isGroupByAllowed: boolean;
    isCommonGroupBy: boolean;
    isMultipleDataSourceAllowed: boolean;
    isMaskCounterAllowed: boolean;
    isConversionAllowed: boolean;
}

export interface WidgetModelInterface {
    id?: string;
    typeId?: string;
    descr?: string;
    commonGroupByList: string[];
    commonGroupByLimit: number;
    maskCounters: boolean;
    maskCountersOnlyOnPublicPage: boolean;
    dataSourceConfigList: DataSourceConfigInterface[];
    conversionBaseDataSourceConfigId: string;
}

export interface GroupByInterface {
    id: string;
    descr: string;
    groupDescr?: string;
}

export type DetailDialogResponse = ReactiveFilterableListRequest<any, any, {
    displayData: any;
    displayTypeId: string;
}>


export interface EditWidgetResponseInterface {
    model: WidgetModelInterface;
    dataSources: DataSourceInterface[];
}
